import type { PortraitOrientation } from './pick-grid-layout';

export const PORTRAIT_ASPECT_RATIOS: Record<PortraitOrientation, number> = {
  vertical: 832 / 1216,
  horizontal: 3 / 2,
};

interface KioskLike {
  portrait_orientation?: unknown;
}

function normalizeOrientation(value: unknown): PortraitOrientation | null {
  return value === 'horizontal' || value === 'vertical' ? value : null;
}

export function resolvePortraitOrientation(
  kiosk: KioskLike | null | undefined
): PortraitOrientation {
  const params =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : null;
  const queryOrientation = normalizeOrientation(
    params?.get('portrait_orientation')
  );
  if (queryOrientation) {
    return queryOrientation;
  }

  return normalizeOrientation(kiosk?.portrait_orientation) ?? 'vertical';
}

export function portraitAspectRatioForOrientation(
  orientation: PortraitOrientation
): number {
  return PORTRAIT_ASPECT_RATIOS[orientation];
}
